<template>
  <div class="w-full relative pb-print-5 flex flex-col justify-center items-center pt-print-5 z-3 print-none layout-head">
    <div
      v-for="(type, screen) in bannerTypes"
      :key="screen"
      class="w-full"
      :class="{
        'hidden md:block': mobileBannerType && screen !== 'mobile',
        'md:hidden': screen === 'mobile'
      }"
    >
      <LazyBannerChatBubble
        v-if="type === 'chat-bubble'"
        @on-link-click="onBannerLinkClick($event)"
      >
        <template #bottom-right>
          <slot />
        </template>
      </LazyBannerChatBubble>

      <LazyBannerRectangleContainer
        v-if="type === 'rectangle-container'"
        @on-link-click="onBannerLinkClick($event)"
      >
        <template #below-right>
          <slot />
        </template>
      </LazyBannerRectangleContainer>

      <LazyBannerBottomContainer
        v-else-if="type === 'bottom-container'"
        @on-link-click="onBannerLinkClick($event)"
      >
        <template #top-right>
          <slot />
        </template>
      </LazyBannerBottomContainer>

      <LazyBannerCenteredText
        v-else
        @on-link-click="onBannerLinkClick($event)"
      >
        <template #bottom-right>
          <slot />
        </template>
      </LazyBannerCenteredText>
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['onLinkClick'])

const rootStore = useRootStore()

const {
  pageBannerType: bannerType,
  pageMobileBannerType: mobileBannerType,
} = storeToRefs(rootStore)

const bannerTypes = computed(() => {
  const bannerTypes = {
    default: bannerType.value,
  }

  if (mobileBannerType.value) {
    bannerTypes.mobile = mobileBannerType.value
  }

  return bannerTypes
})

const onBannerLinkClick = (scrollToId) => {
  emit('onLinkClick')

  if (scrollToId) {
    scrollToBanner(scrollToId)
  }
}

const scrollToBanner = (bannerID) => {
  const findBanner = document.querySelector(`#${bannerID}`)

  if (findBanner) {
    findBanner.scrollIntoView({
      behavior: 'smooth',
    })
  }
}
</script>
